import { parsedOption } from "helpers/parsed/parsedOption";
import { IUserContext } from "Interfaces/Providers/User";
import { createContext, ReactNode, useCallback, useState } from "react";

import user from "services/user";
import { useImmer } from "use-immer";

import { ShowErrorUser, ShowSuccessUSer } from "components/Toast/Index";
import { useToast } from "@chakra-ui/react";
interface Auth0ProviderProps {
  children: ReactNode;
}

const UserProvider = ({ children }: Auth0ProviderProps) => {
  // const toast = useToast();

  const [loading, setLoading] = useState(false);
  const [loadingGeneral, setLoadingGeneral] = useState(true);
  const [isFirstData, setFirstData] = useState(true);
  const [pageCurrent, setPageCurrent] = useState(1);
  const [total, setTotal] = useState(10);
  const toast = useToast();

  const [data, updateData] = useImmer<any[]>([]);
  const [suppliers, setSupplier] = useImmer<any[]>([]);

  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [dataUpdate, updateDataUpdate] = useImmer<any>({});
  const [dataUpdateSuppliers, updateDataUpdateSuppliers] = useImmer<any[]>([]);

  const [loadingGeneratePassword, setLoadingGeneratePassword] = useState(false);

  const getData = useCallback(
    async (search: any, page: any, total: any) => {
      setLoading(false);
      setFirstData(false);
      setLoadingGeneral(true);

      user
        .getData(search, 0, page * 20)
        .then((response) => {
          const newData = [...data, ...response.data?.data];

          if (search !== "") {
            updateData(response.data?.data);
          } else {
            updateData(response.data?.data);
          }
          setLoading(false);

          const headers = response.headers;
          const xTotal = response.headers["x-total-count"];
          setTotal(xTotal);
          setFirstData(false);
          setPageCurrent(page);
          setLoadingGeneral(false);
        })
        .catch(() => {
          setLoading(false);
          setLoadingGeneral(false);
        });
    },
    [updateData, data, setPageCurrent]
  );

  const getDataById = useCallback(
    async (id: any, obj: any) => {
      setLoadingUpdate(true);
      user
        .getDataById(id)
        .then((response) => {
          updateDataUpdate(obj);
          updateDataUpdateSuppliers(response.data?.data);
          setLoadingUpdate(false);
        })
        .catch(() => {
          updateDataUpdate(obj);
          updateDataUpdateSuppliers([]);

          setLoadingUpdate(false);
        });
    },
    [updateDataUpdate, updateDataUpdateSuppliers]
  );

  const removeUpdateData = useCallback(async () => {
    updateDataUpdate({});
  }, [updateDataUpdate]);

  const getSuppliers = useCallback(async () => {
    setFirstData(false);

    user
      .getSuppliers()
      .then((response) => {
        setSupplier(parsedOption(response.data?.data));
      })
      .catch(() => {
        // setLoading(false);
      });
  }, [setSupplier]);

  const postData = useCallback(async (obj: any) => {
    setFirstData(false);

    user
      .postData(obj)
      .then((response) => {
        getData("", 1, 20);
        ShowSuccessUSer(response?.data?.message);
      })
      .catch((error: any) => {
        const { data } = error.response;

        const message =
          data.message !== null
            ? data.message
            : "Ocorreu um problema interno. Tente novamente mais tarde";
        toast({
          title: "Error",
          description: message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  }, []);

  const putData = useCallback(async (obj: any, id: any) => {
    setFirstData(false);
    user
      .putData(obj, id)
      .then((response) => {
        getData("", 1, 20);
        ShowSuccessUSer(response?.data?.message);
      })
      .catch((error: any) => {
        const { data } = error.response;

        const message =
          data.message !== null
            ? data.message
            : "Ocorreu um problema interno. Tente novamente mais tarde";
        toast({
          title: "Error",
          description: message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  }, []);

  const deleteData = useCallback(
    async (id: number) => {
      // setLoading(true);
      setFirstData(false);
      let newParams = {};
      user
        .deleteData(id)
        .then((response) => {
          getData("", 1, 20);
          ShowSuccessUSer(response?.data?.message);
        })
        .catch(() => {
          // setLoading(false);
        });
    },
    [getData]
  );

  const generatePassword = useCallback(async (id: number): Promise<string> => {
    try {
      // setLoading(true);
      setLoadingGeneratePassword(true);
      setFirstData(false);

      const response = await user.generatePassword(id);

      setLoadingGeneratePassword(false);
      ShowSuccessUSer(response?.data?.message);
      return response?.data?.data || "";
    } catch (error) {
      ShowErrorUser(error);
      setLoadingGeneratePassword(false);
      console.error("Erro ao gerar senha:", error);
      return "";
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        loading,
        loadingGeneral,
        loadingGeneratePassword,
        data,
        isFirstData,
        pageCurrent,
        total,
        suppliers,
        dataUpdate,
        loadingUpdate,
        dataUpdateSuppliers,
        getDataById,
        removeUpdateData,
        getData,
        generatePassword,
        getSuppliers,
        deleteData,
        putData,
        postData,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
export const UserContext = createContext<IUserContext>({} as IUserContext);
